<template>
  <div>
    <h2 class="person-title">{{this.$t('userInfo.MyPosts')}}</h2>
    <el-table  v-loading="loading"
               element-loading-text="Loading"
               element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(255, 255, 255, 0.3)"
               v-loading.fullscreen.lock="fullscreenLoading"
      :data="newsContent"
      @cell-click="handle"
      stripe
      row-class-name="row-style"
      style="width: 100%">
      <el-table-column
        prop="createTime"
        :label="$t('userInfo.Date')"
        width="180">
      </el-table-column>
      <el-table-column
        prop="title"
        :label="$t('common.Title')"
        id="title">
      </el-table-column>
      <el-table-column
        prop="status"
        :label="$t('userInfo.Status')"
        id="status"
        width="100">
      </el-table-column>
      <el-table-column
        prop="hits"
        :label="$t('userInfo.Views')"
        width="80">
      </el-table-column>
      <el-table-column :label="$t('userInfo.Options')" width="120">
        <template slot-scope="scope">
          <el-button @click="handleChangeClick(scope.row)" type="text" size="small">{{$t('userInfo.Edit')}}</el-button>
          <el-button type="text" size="small" @click="handleDeleteClick(scope.row)">{{$t('userInfo.Delete')}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="number"
      :page-size="size"
      id="pagination"
      layout="total, prev, pager, next, jumper"
      :total="totalElements">
    </el-pagination>


  </div>

</template>

<script>
  import axios from '../../axios'

  export default {
    name: "mySubmission",
    data() {
      return {
        loading: true,
        fullscreenLoading: true,
        url: 'news',
        newsContent: [],
        totalPages: 0,//总页数
        totalElements: 0, //总条数
        size: 0, //当前页条数
        number: 1, //当前页从1开始
      }
    },
    components: {},
    created() {
      this.getUserArticle();
      // console.log(this.totalElements);
    },
    methods: {
      getUserArticle(currentPage = 1) {
        let _this = this;
        axios.get(this.$store.state.apiBasePath + "/article/me" + "?page=" + currentPage)
          .then(function (res) {
            var resData = res.data;
            // console.log(resData);
            if (resData.code === 200) {
              _this.loading=false;
              _this.fullscreenLoading=false;
              _this.newsContent = resData.data.content;

              _this.totalPages = resData.data.totalPages;
              _this.totalElements = resData.data.totalElements;
              _this.number = resData.data.number + 1;//服务器返回数据从0开始，分页组件从1开始，所以要加1
              _this.size = resData.data.size;
            } else {
              this.$message({
                title:this.$t('message.Error'),
                message:res.data.msg,
                type: 'error',
                showClose: true,
                offset:300,
                duration:3000,
              });
            }
          })
      },
      //点击标题跳转详情页面
      handle(row, column) {
        var title = column.label;
        if (title == this.$t('common.Title')) {
          let routeData = this.$router.resolve({path: "/contentPage/" + row.id});
          //点击跳转新页面
          window.open(routeData.href, '_blank');
        }
      },

      // 修改我的投稿
      handleChangeClick(row) {
        // console.log(row);
        let routeData = this.$router.resolve({path: "/submission/", query: {articleId: row.id}});
        //点击跳转新页面
        window.open(routeData.href, '_blank');
      },
      // 删除投稿
      handleDeleteClick(row) {
        let _this=this;
        axios.get(this.$store.state.apiBasePath + '/article/delete/' + row.id)
          .then(function (res) {
            // console.log(res);
            if (res.data.code === 200) {
              _this.$confirm(_this.$t('message.deleteFile'), _this.$t('message.Prompt'), {
                confirmButtonText: _this.$t('common.Ok'),
                cancelButtonText: _this.$t('common.Cancel'),
                type: 'warning'
              }).then(() => {
                _this.$message({
                  type: 'success',
                  message: _this.$t('message.Successfully'),
                  showClose: true,
                  offset:300,
                  duration:3000,
                  onClose:function () {
                    //删除成功刷新页面
                    _this.getUserArticle();
                  }
                });
              });
            }else {
              _this.$message({
                type: 'error',
                title:_this.$t('message.Error'),
                message:res.data.msg,
                showClose: true,
                offset:300,
                duration:3000,
              });
            }
          });
      },

      //当前页  currentPage 改变时会触发
      handleCurrentChange: function (currentPage) {
        this.number = currentPage;
        this.getUserArticle(currentPage);
      },
    }
  }
</script>

<style>
  .person-title {
    border-bottom: #ddd 1px solid;
    padding-bottom: 10px;
    color: #000;
  }

  .el-pagination {
    margin: 20px 0;
  }
  .el-table_1_column_2:hover{cursor: pointer;}

</style>



// WEBPACK FOOTER //
// src/components/userCenter/mySubmission.vue